import classnames from 'classnames';
import React from 'react';

function messageBoxOfType(type) {
  return ({className, message, ...props}) => {
    return message ?
      <p className={classnames("alert alert-"+type, className)} {...props}>
        {message}
      </p> : null;
  };
}

export const SuccessBox = messageBoxOfType("success");
export const InfoBox = messageBoxOfType("info");
export const WarningBox = messageBoxOfType("warning");
export const ErrorBox = messageBoxOfType("danger");

export function RestResultMessage({result, className, ...props}) {
  if (!result || !result.message) return null;

  const type = result.isError ? "danger" : "success";
  return <div className={classnames("rest-result-message alert alert-"+type, className)} {...props}>
    <PlainRestResultMessage result={result} />
  </div>;
}

export function PlainRestResultMessage({result}) {
  const {message, validationErrors = []} = result;
  return <React.Fragment>
    <strong>{message}</strong>
    {validationErrors.map((err,i) => <p key={i}><strong>{err.fieldName}:</strong> {err.message}</p>)}
  </React.Fragment>;
}



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/MessageBox.jsx